import React from 'react';
import SettingsPartial from '../_partial/Settings.partial';
import LanguageSelectorPartial from '../_partial/LanguageSelector.partial';

const DefaultHeaderRightCommon = () => {
	return (
		<>
			<SettingsPartial />
			<LanguageSelectorPartial />
		</>
	);
};

export default DefaultHeaderRightCommon;
